// extracted by mini-css-extract-plugin
module.exports = {"container":"usercodes_container__1Co7Y","backButton":"usercodes_backButton__2-LR3","headerUsercode":"usercodes_headerUsercode__lrmlh"};